import { createApp } from 'vue'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'
import { createGtm } from '@gtm-support/vue-gtm'

import stores from './stores'
import router from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'

import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

import App from './App.vue'
import { devLog } from './services/logger'

// Suppress browser extension errors
window.addEventListener('error', (event) => {
  if (
    event.filename === '' ||
    event.filename.includes('moz-extension://') ||
    event.filename.includes('chrome-extension://')
  ) {
    devLog('Browser extension error suppressed:', event.message)
    event.preventDefault()
    return false
  }
})

// Suppress unhandled promise rejections from extensions
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.stack && event.reason.stack.includes('<anonymous>')) {
    devLog('Browser extension promise rejection suppressed:', event.reason.message)
    event.preventDefault()
    return false
  }
})

const app = createApp(App)

app.use(stores)
app.use(router)
app.use(i18n)
app.use(createVuestic({ config: vuesticGlobalConfig }))

app.use(VueSweetalert2)

if (import.meta.env.VITE_APP_GTM_ENABLED) {
  app.use(
    createGtm({
      id: import.meta.env.VITE_APP_GTM_KEY,
      debug: false,
      vueRouter: router,
    }),
  )
}

app.mount('#app')
